import React from 'react';

import { cssVarsStyle } from './css-vars-style';
import type { CssFieldDescriptor } from './types';

type CssVarsWrapperProps = {
  [prop: string]: unknown;
  descriptors: readonly CssFieldDescriptor[];
  children: React.ReactNode;
};

/**
 * Scopes CSS custom properties to a subtree without adding layout impact.
 * Uses `display: contents` so this wrapper is invisible to the layout engine
 * while still allowing CSS variables to cascade into child styled-components.
 */
export function CssVarsWrapper({ descriptors, children, ...props }: CssVarsWrapperProps): JSX.Element {
  const style = cssVarsStyle(descriptors, props);

  return <div style={{ display: 'contents', ...style }}>{children}</div>;
}
